export const companyClassificationListx = [
  // {id: 1, name: "BUSINESS NAME", description: "Business Name"},
  {id: 2, name: "COMPANY", description: "Company"},
  {id: 3, name: "INCORPORATED TRUSTEE", description: "Incorporated Trustee"},
  {id: 4, name: "LIMITED PARTNERSHIP", description: "LIMITED PARTNERSHIP"},
  {id: 5, name: "LIMITED LIABILITY PARTNERSHIP", description: "LIMITED LIABILITY PARTNERSHIP"},
];


export const companyClassificationList: any[] =
  companyClassificationListx.sort((a, b) => {
    if (a.name > b.name) {
      return 1;
    }
    if (a.name < b.name) {
      return -1;
    }
    return 0;
  })
